import React, { useEffect, useState } from 'react';
import { cn } from './_cn';

const GRADIENT_COLORS = [
  'from-blue-500 to-sky-500',
  'from-violet-500 to-purple-500',
  'from-emerald-500 to-teal-500',
  'from-rose-500 to-pink-500',
  'from-amber-500 to-orange-500',
  'from-cyan-500 to-blue-500',
];

export const getAvatarColor = (name) => {
  const s = String(name || '');
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + hash * 31;
  }
  return GRADIENT_COLORS[Math.abs(hash) % GRADIENT_COLORS.length];
};

export const getInitials = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || '').join('') || '?';
};

const sizes = {
  xs: 'h-6 w-6 text-[0.6rem]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-14 w-14 text-lg',
};

const UserAvatar = ({
  name,
  size = 'md',
  onClick,
  src,
  className = '',
}) => {
  const Tag = onClick ? 'button' : 'span';
  // A photo that fails to load draws the initials, so a broken URL looks like
  // "no photo"; a new src gets a fresh try.
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);
  const showPhoto = Boolean(src) && !failed;
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold text-white shadow-sm',
        // The gradient is for initials only; a photo (a transparent PNG too)
        // sits on a neutral backdrop.
        showPhoto
          ? 'bg-slate-100 ring-1 ring-inset ring-slate-900/5 dark:bg-slate-700 dark:ring-white/10'
          : cn('bg-gradient-to-br', getAvatarColor(name)),
        sizes[size] || sizes.md,
        onClick ? 'cursor-pointer transition hover:shadow-md' : '',
        className,
      )}
      aria-label={name || 'User avatar'}
    >
      {showPhoto ? (
        <img
          src={src}
          alt=""
          draggable={false}
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <span>{getInitials(name)}</span>
      )}
    </Tag>
  );
};

export default UserAvatar;
